import { QuestionViewModel } from "./question.model";
import { CategoryModel } from "./category.model";

export class CategoryViewModel{
    categoryModel:CategoryModel;
    questionsViewModel: Array<QuestionViewModel>
    selectedAssigneeId: number = 0;
    isSubmitted: boolean;
    discrepancyRaised: boolean;
    isQuestionTableVisible:boolean = false;
    startDate?: string;
    isAccordionOpen: boolean;
}